// Global variable to store the fetched product data
let currentProduct = null;


// Conversion function: converts an inches measurement string to centimeters (rounded up)
function convertToCm(inchStr) {
    // Helper: parse an inch value
    function parseInchValue(val) {
        val = val.trim();
        // If there is a space (mixed number, e.g., "26 3/8")
        if (val.indexOf(' ') !== -1) {
            const parts = val.split(' ');
            const whole = parseFloat(parts[0]);
            const fracParts = parts[1].split('/');
            if (fracParts.length === 2) {
                const fraction = parseFloat(fracParts[0]) / parseFloat(fracParts[1]);
                return whole + fraction;
            }
            return whole;
        }
        // Try matching a merged pattern (e.g., "263/8" is "26" with "3/8")
        const mergedMatch = val.match(/^(\d+)(\d\/\d+)$/);
        if (mergedMatch) {
            const whole = parseFloat(mergedMatch[1]);
            const fracParts = mergedMatch[2].split('/');
            if (fracParts.length === 2) {
                const fraction = parseFloat(fracParts[0]) / parseFloat(fracParts[1]);
                return whole + fraction;
            }
            return whole;
        }
        // If it's a pure fraction (e.g., "3/8")
        if (val.indexOf('/') !== -1) {
            const fracParts = val.split('/');
            if (fracParts.length === 2) {
                return parseFloat(fracParts[0]) / parseFloat(fracParts[1]);
            }
        }
        // Otherwise, assume a simple number
        return parseFloat(val) || 0;
    }

    const inchValue = parseInchValue(inchStr);
    const cmValue = inchValue * 2.54;
    return Math.ceil(cmValue); // Round up to nearest whole number
}

// Format inches: wrap any fractional part in a <sup> tag.
function formatInches(inchStr) {
    let trimmed = inchStr.trim();
    // If mixed number with a space exists
    if (trimmed.includes(" ")) {
        const parts = trimmed.split(" ");
        return `${parts[0]} <sup>${parts.slice(1).join(" ")}</sup>`;
    }
    // If merged pattern like "263/8"
    const mergedMatch = trimmed.match(/^(\d+)(\d\/\d+)$/);
    if (mergedMatch) {
        return `${mergedMatch[1]} <sup>${mergedMatch[2]}</sup>`;
    }
    // If pure fraction, wrap in <sup>
    if (/^\d+\/\d+$/.test(trimmed)) {
        return `<sup>${trimmed}</sup>`;
    }
    return trimmed;
}

// Render the size chart table based on the product data and selected unit.
function renderTable(product, unit) {
    if (!product || !product.acf || !product.acf.inches) return;
    const inchesData = product.acf.inches;

    const headerHtml = (inchesData.use_header && inchesData.header && inchesData.header.length)
        ? `<thead class="">
          <tr>
            ${inchesData.header.map(headerItem => `
              <th scope="col" class="text-center text-xs font-medium uppercase tracking-wider">
                ${headerItem.c}
              </th>
            `).join('')}
          </tr>
        </thead>`
        : '';

    const bodyHtml = `<tbody class="">
       ${inchesData.body.map(row => `
         <tr>
           ${row.map((cell, index) => {
        let cellValue = cell.c;
        if (index !== 0) {
            if (unit === "cm") {
                cellValue = convertToCm(cellValue);
            } else {
                cellValue = formatInches(cellValue);
            }
        }
        return `<td class="whitespace-nowrap text-sm">
                       ${cellValue}
                     </td>`;
    }).join('')}
         </tr>
       `).join('')}
     </tbody>`;

    const tableHtml = `
     <table class="table_size_guide table table-dark text-center border-1 mb-0">
       ${headerHtml}
       ${bodyHtml}
     </table>`;

    const targetElement = document.querySelector('[data-size-inches]');
    if (targetElement) {
        targetElement.innerHTML = tableHtml;
    }
}

function renderImage(product) {
    // grab your wrapper/container for the model image
    const holder = document.querySelector('.model-image-holder');
    // grab the size chart container
    const sizeChart = document.querySelector('.size-chart-container');
    // grab the inner target where you inject the <img>
    const targetElement = document.querySelector('[data-model-image]');

    // check: do we have a valid featured image URL?
    const hasImage =
        product &&
        product.better_featured_image &&
        product.better_featured_image.source_url;

    if (!hasImage) {
        // no image → hide the image-holder...
        if (holder) holder.classList.add('d-none');
        // ...and make the size chart span full width
        if (sizeChart) sizeChart.style.width = '100%';
        return;
    }

    // we do have an image → show the holder and reset size-chart width
    if (holder) holder.classList.remove('d-none');
    if (sizeChart) sizeChart.style.width = '';

    const featuredImage = product.better_featured_image;
    const mediaDetails = featuredImage.media_details;
    let srcset = '';

    if (mediaDetails && mediaDetails.sizes) {
        const srcsetArray = Object.values(mediaDetails.sizes)
            .filter(size => size.source_url && size.width)
            .map(size => `${size.source_url} ${size.width}w`);
        srcset = srcsetArray.join(', ');
    }

    const fallbackSrc = featuredImage.source_url;
    const altText = featuredImage.alt_text || '';
    const imageHtml = `
 <img
   src="${fallbackSrc}"
   srcset="${srcset}"
   alt="${altText}"
   class="w-full h-auto"
 >
`;

    if (targetElement) {
        targetElement.innerHTML = imageHtml.trim();
    }
}



// Render the product's description details instead of the featured image.
function renderDescription(product) {
    if (!product || !product.acf || !product.acf.description_details) return;

    // The description text is already HTML (paragraph tags, etc.).
    const descHTML = product.acf.description_details;

    // Insert into whatever element you’ve set up to hold the copy.
    // Example: <div data-product-description></div>
    const targetElement = document.querySelector('[data-product-description]');
    if (targetElement) {
        targetElement.innerHTML = descHTML;
    }
}




(function attachSizeLogic(){
    let currentProduct = null;
  
    const qAll = (sel) => Array.from(document.querySelectorAll(sel));
    const showSizeChart = () => {
      qAll('.size_chart').forEach(el => el.classList.remove('d-none'));
      qAll('.wp__size-guide').forEach(el => el.classList.add('d-none'));
      console.log('STATE: show .size_chart, hide .wp__size-guide');
    };
    const showWpGuide = () => {
      qAll('.size_chart').forEach(el => el.classList.add('d-none'));
      qAll('.wp__size-guide').forEach(el => el.classList.remove('d-none'));
      console.log('STATE: hide .size_chart, show .wp__size-guide');
    };
  
    const run = () => {
      const link = document.getElementById('size__chart');            // your <modal-opener>
      const slugID = link?.getAttribute('data-size-style');
  
      // If the trigger or slug is missing, default to showing the size chart (your WP guide off)
      if (!link || !slugID) {
        console.warn('Missing #size__chart or data-size-style — defaulting to .size_chart');
        showSizeChart();
        return;
      }
  
      const url = `https://laapparel.info/wp-json/wp/v2/wholesale_product?slug=${encodeURIComponent(slugID)}`;
  
      fetch(url)
        .then(r => r.json())
        .then(products => {
          console.log('API result:', products);
  
          // Endpoint empty => show .size_chart, hide .wp__size-guide
          if (!Array.isArray(products) || products.length === 0) {
            currentProduct = null;
            showSizeChart();
            return;
          }
  
          currentProduct = products[0];
          const inchesFlag = currentProduct?.acf?.inches;
  
          // If inches === false -> show size chart; otherwise show WP guide
          inchesFlag === false ? showSizeChart() : showWpGuide();
        })
        .catch(err => {
          console.error('Error fetching product data:', err);
          // Treat errors like empty
          showSizeChart();
        });
  
      // Optional: if you only want to render details when data exists
      link.addEventListener('click', (e) => {
        e.preventDefault();
        if (!currentProduct) return;
        const selectedUnit = document.querySelector('input[name="unit"]:checked')?.value || 'in';
        renderTable(currentProduct, selectedUnit);
        renderImage(currentProduct);
        renderDescription(currentProduct);
      });
  
      document.querySelectorAll('input[name="unit"]').forEach(radio => {
        radio.addEventListener('change', () => {
          const selectedUnit = document.querySelector('input[name="unit"]:checked')?.value || 'in';
          if (currentProduct) renderTable(currentProduct, selectedUnit);
        });
      });
    };
  
    // Run now
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
  
    // Also run on Shopify section loads (important on PDP)
    document.addEventListener('shopify:section:load', run);
  })();